<div class="row">
  <div class="col-12 md--border__right">
    <div class="row modal-row modal-heading">
      <div class="col-6 col-sm-6 tt-buy-hgt">
        <label style="min-width: 130px;">{{option?.valueTitle}}</label>
        <br>
        <!-- <span class="notice-text">({{option?.valueUnit}})</span> -->
      </div>
      <div class="col-6 col-sm-6 text-right tt-buy-hgt">
        <label class="pull-right">{{option?.feeTitle}}</label>
        <br>
        <!-- <span class="notice-text">({{option?.feeUnit}})</span> -->
      </div>
    </div>
    <div class="row row-color" *ngFor="let item of fees, index as index">
      <div class="col-10 col-sm-10 tt-buy-hgt no-padding-right">
        <label *ngIf="index === 0 && index !== fees.length-1">
          {{item.endRelationalOperator?.name}} {{item.endVolume | money}} {{option?.valueUnit}}
        </label>
        <label *ngIf="index === fees.length-1">
          {{item.beginRelationalOperator?.name}} {{item.beginVolume | money}} {{option?.valueUnit}}
        </label>
        <label *ngIf="index !== 0 && index !== fees.length-1">
          {{item.beginVolume | money}} - {{item.endVolume | money}} {{option?.valueUnit}}
        </label>
      </div>
      <div class="col-2 col-sm-2 text-right tt-buy-hgt">
        <label class="label-name">{{item.fee}}{{option?.feeUnit}}</label>
      </div>
    </div>
    <div class="row row-color" *ngIf="!fees.length" style="justify-content: center;">
      <span>Không có phí</span>
    </div>
  </div>
</div>